import { Component, ViewContainerRef, ViewChild } from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { ProviderContext, Providers } from '../../data/Entities';
import { DatePipe } from '@angular/common';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
    selector: 'deliveryfrm',
    templateUrl: '/templates/get/Settings/delivery_frm',
})
export class DeliverySettingsComponent {
    PCODE = 'SETTINGS';
    public rows = [];
    public entity: any = {};

    ctx = new ProviderContext({
        ProviderCode: this.PCODE,
    });

    constructor(public siteServices: SiteServices) {
        this.siteServices.provider_GetDataByID(
            this.PCODE,
            'DelivererAvailabilityPercent',
            '',
            (data) => {
                if (data.TagObject)
                    this.entity.DelivererAvailabilityPercent =
                        data.TagObject.Value;
            }
        );
    }

    save() {
        this.siteServices.provider_Save(
            this.PCODE,
            {
                Key: 'DelivererAvailabilityPercent',
                Section: 'Delivery',
                Value: this.entity.DelivererAvailabilityPercent,
            },
            (data) => {
                this.siteServices.success('Save Done');
            }
        );
    }
}
